import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { Redirect } from 'react-router-dom'

import { DomainContext } from '../../domain-repository/DomainRepository'

import withLang from '../../withLang'
import DriverInfoHeader from '../../components/PageHeader'
import { FooterWithPrice } from '../../components/Footer'
import TrackingPage from '../../components/TrackingPage'

function BabySeatsPage(props) {
  const { t } = useTranslation()

  const {
    getBabySeatExtras,
    addExtra,
    removeExtra,
    getQuantityOfExtra,
    userAnswers,
    isCorporate,
    rentalAgreementQuoteValue,
    flowNextRoute,
    reservationExtras,
    getQuantityOfExtraInReservation,
    saveSessionExtras,
  } = useContext(DomainContext)

  function getBabySeatExtrasToRender() {
    return getBabySeatExtras().map(extra => (
      <div key={extra.extraID} className="board-background mt-2">
        <div className="block-header d-flex align-items-center">
          <div className="ico">
            <img src={require(`./icons/${extra.iconName}`)} alt={`${extra.name} icon`} />
          </div>
          <div className="block-title">
            <h2>{t(`${extra.id}Name`)}</h2>
            <i className="d-block">({t(`${extra.id}Hint`)})</i>
            <p>{t(`${extra.id}Description`)}</p>
          </div>
        </div>
        <div className="block-content mt-2">

        </div>
        <div className="row justify-content-end">
          <div className="block-value col d-flex align-items-center justify-content-end">
            <span>€{extra.pricePerDay} /{t('day')}</span>
            <div className="range d-flex">
              <button onClick={() => { if (getQuantityOfExtra(extra) > 0) { removeExtra(extra) } }} className="btn-remove"></button>
              <span className="range-value">{getQuantityOfExtra(extra) + getQuantityOfExtraInReservation(extra.extraID)}</span>
              <button onClick={() => addExtra(extra)} className="btn-add"></button>
            </div>
          </div>
        </div>
      </div>
    ));
  }

  function handleNextClick() {
    const mappedExtras = getBabySeatExtras().map(e => ({
      extraId: e.extraID,
      price: e.totalPrice,
      acquired: getQuantityOfExtra(e) > 0,
      removedInReview: false,
      pageId: PageId,
    }))

    saveSessionExtras(mappedExtras)

    props.history.push(flowNextRoute())
  }

  return userAnswers.babySeat ? (
    <div>
      <DriverInfoHeader
        title={t('safety')}
        active={2}
        progress={'60%'}
        handleLogoClick={() => props.history.push('/start')}
      />
      <main className='page-layout'>
        <div className="container grow">
          <div className="main" style={{ height: '100%' }}>
            <div className="header text-center">
              <div className="text-center">
                <h2>{t('babySeatTitle')}</h2>
              </div>
            </div>
            <div className="block-container container-large mx-auto">
              <p className="p-3 m-0">{t('babySeatLawDescription')}</p>
              {getBabySeatExtrasToRender()}
            </div>
          </div>
        </div>
        <FooterWithPrice
          totalPrice={rentalAgreementQuoteValue}
          totalPriceLabel={t('total')}
          handleNextClick={handleNextClick}
          handlePrevClick={() => props.history.goBack()}
        />
      </main>
    </div>
  ) : <Redirect to="/upselling" />
}

const PageId = 82
export default withLang(TrackingPage(BabySeatsPage, PageId))
